// =============================================================================
// GuardedLink — a <Link> that asks before walking away from unsaved work.
//
// GuardedNavLink covers the app's own navigation (bottom bar, rail); the back
// arrow and ⌘K consult the same registry. An IN-PAGE link is the exit those
// cannot see: Scouting mid-walk had "Plan spray →" on the very card a scout
// had just logged, and "View on scouting map" in the open finding, and both
// left the page — stopping the GPS — with no question (farm audit SC-07, fix
// round 1). A page whose links can leave while it holds unsaved work uses this
// in place of <Link>.
//
// Drop-in for Link: same props. Its own onClick runs FIRST (stopPropagation,
// closing a panel); the guard then runs unless that onClick cancelled the
// click. On a clean page, a modified click, or a link to the URL on screen it
// does nothing and the Link navigates as it always did (guardLeaveClick). When
// it asks and the operator agrees, it navigates with the Link's own state,
// replace and relative, so a return state (`useReturnHereState`) survives.
// =============================================================================

import { Link, useLocation, useNavigate, useResolvedPath, type LinkProps } from 'react-router-dom'
import { guardLeaveClick } from '@/lib/pageDirty'

export default function GuardedLink({ onClick, ...props }: LinkProps) {
  const navigate = useNavigate()
  const here = useLocation()
  const target = useResolvedPath(props.to, { relative: props.relative })
  return (
    <Link
      {...props}
      onClick={e => {
        onClick?.(e)
        guardLeaveClick(e, target.pathname + target.search, here.pathname + here.search,
          () => navigate(props.to, { state: props.state, replace: props.replace, relative: props.relative }))
      }}
    />
  )
}
